import { render } from "./AttendanceSummaryReport.vue?vue&type=template&id=b80a3b9a"
import script from "./AttendanceSummaryReport.vue?vue&type=script&lang=js"
export * from "./AttendanceSummaryReport.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__